import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import HorizontalMenu from 'components/Menus/HorizontalMenu';
import Integrations from './Integrations';

import './business-settings.scss';
import './legacy-org-settings-menu.scss';

const BUSINESS = 'business';
const BANKING = 'banking';
const USERS = 'users';
const BRANDING = 'branding';
const LEADS = 'leads';
const TEMPLATES = 'templates';
const INTEGRATIONS = 'integrations';

const BusinessSettings = () => {
  const orgSettings = useSelector(state => state.global.menuPermissions.orgSettings);

  const {
    business,
    banking,
    users,
    branding,
    leads,
    templates,
    integrations,
  } = orgSettings;

  const { orgId, activeTab } = useParams();
  const history = useHistory();

  const getSettingsTab = () => {
    if (orgSettings[activeTab]) {
      return activeTab;
    }

    // if there is no permission to the tab
    // show first tab available to the user
    return Object.entries(orgSettings).find(([, value]) => value === true)[0];
  };

  const goToLegacySetting = (e, page) => {
    e.preventDefault();
    if (!page) {
      window.location.href = `/app/pro/${orgId}/settings`;
      return;
    }
    window.location.href = `/app/pro/${orgId}/settings/${page}`;
  };

  const [settingsTab, setSettingsTab] = useState(getSettingsTab());

  const tabs = [
    ... business ? [{
      id: 'business',
      name: 'business',
      onClick: goToLegacySetting,
      active: settingsTab === BUSINESS,
    }] : [],
    ... banking ? [{
      id: 'banking',
      name: 'banking',
      onClick: (e) => goToLegacySetting(e, 'payments'),
      active: settingsTab === BANKING,
    }] : [],
    ... users ? [{
      id: 'users',
      name: 'team',
      onClick: (e) => goToLegacySetting(e, 'members'),
      active: settingsTab === USERS,
    }] : [],
    ... branding ? [{
      id: 'branding',
      name: 'branding',
      onClick: (e) => goToLegacySetting(e, 'branding'),
      active: settingsTab === BRANDING,
    }] : [],
    ... leads ? [{
      id: 'leads',
      name: 'leads',
      onClick: (e) => goToLegacySetting(e, 'leads'),
      active: settingsTab === LEADS,
    }] : [],
    ... templates ? [{
      id: 'templates',
      name: 'templates',
      onClick: (e) => goToLegacySetting(e, 'templates'),
      active: settingsTab === TEMPLATES,
    }] : [],
    ... integrations ? [{
      id: 'integrations',
      name: 'integrations',
      onClick: () => {
        setSettingsTab(INTEGRATIONS);
        history.push(`/app/v2/pro/${orgId}/settings/integrations`);
      },
      active: settingsTab === INTEGRATIONS,
    }] : [],
  ];

  return (
    <div className="business-settings">
      <HorizontalMenu
        items={tabs}
        className="horizontal-menu--business-settings"
      />

      <div className="container container--business-settings">
        {settingsTab === BUSINESS && (<p>BUSINESS</p>)}

        {settingsTab === BANKING && (<p>BANKING</p>)}

        {settingsTab === USERS && (<p>USERS</p>)}

        {settingsTab === BRANDING && (<p>BRANDING</p>)}

        {settingsTab === LEADS && (<p>LEADS</p>)}

        {settingsTab === TEMPLATES && (<p>TEMPLATES</p>)}

        {settingsTab === INTEGRATIONS && (<Integrations />)}
      </div>
    </div>
  );
};

export default BusinessSettings;
